<router-outlet></router-outlet>
<div>
  <router-outlet name="modalrouter"></router-outlet>
</div>
<div>
  <router-outlet name="viewrouter"></router-outlet>
</div>
